export default "__VITE_ASSET__Bw4S6lMF__"